// Regions have been removed from all location dropdowns — the country list alone is now shown
// for every location-related field. The REGIONS array is retained here only for reference /
// admin-side reporting; it is no longer surfaced in any form option list.
export const REGIONS = [
  "Southeast Asia",
  "Northeast Asia",
  "South Asia",
  "North America",
  "Latin America",
  "Middle East",
  "Africa",
  "Europe",
  "Oceania",
];

export const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Angola", "Argentina", "Armenia", "Australia", "Austria",
  "Azerbaijan", "Bahrain", "Bangladesh", "Belarus", "Belgium", "Bolivia", "Bosnia and Herzegovina",
  "Brazil", "Brunei", "Bulgaria", "Cambodia", "Cameroon", "Canada", "Chile", "China", "Colombia",
  "Congo (DRC)", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Ecuador",
  "Egypt", "Ethiopia", "Finland", "France", "Georgia", "Germany", "Ghana", "Greece", "Guatemala",
  "Hungary", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Japan", "Jordan",
  "Kazakhstan", "Kenya", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Libya", "Lithuania",
  "Luxembourg", "Malaysia", "Mexico", "Moldova", "Mongolia", "Morocco", "Mozambique", "Myanmar",
  "Nepal", "Netherlands", "New Zealand", "Nigeria", "North Korea", "Norway", "Oman", "Pakistan",
  "Panama", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia",
  "Saudi Arabia", "Senegal", "Serbia", "Singapore", "Slovakia", "Slovenia", "South Africa",
  "South Korea", "Spain", "Sri Lanka", "Sudan", "Sweden", "Switzerland", "Syria", "Taiwan",
  "Tajikistan", "Tanzania", "Thailand", "Tunisia", "Turkey", "Turkmenistan", "Uganda", "Ukraine",
  "United Arab Emirates", "United Kingdom", "United States", "Uzbekistan", "Venezuela", "Vietnam",
  "Yemen", "Zambia", "Zimbabwe",
];

// Sentinel values retained for backward-compat with any lingering admin/read views;
// no longer emitted by the option lists below.
export const HEADER_REGIONS = "__H_REGIONS";
export const HEADER_COUNTRIES = "__H_COUNTRIES";

// Country-only lists (regions removed).
export const REGION_AND_COUNTRY_OPTIONS = [...COUNTRIES];

// Used for sourcing / asset locations — includes N/A at the end
export const LOCATION_OPTIONS = [...COUNTRIES, "N/A"];

// Country-only single-select list for HQ / single-country dependency / concern-country.
export const COUNTRY_SELECT_OPTIONS = [...COUNTRIES];

export const ROLES = [
  "CEO / Managing Director",
  "CFO / Finance Director",
  "Chief Strategy Officer",
  "Chief Risk Officer",
  "COO / Operations Director",
  "Supply Chain / Procurement Head",
  "Legal / Compliance Head",
  "Board Member",
  "Other",
];

export const INDUSTRIES = [
  "Energy",
  "Financial Services",
  "Manufacturing",
  "Technology",
  "Infrastructure",
  "Trade & Logistics",
  "Professional Services",
  "Government / Public Sector",
  "Other",
];

export const COMPANY_SIZES = ["<50", "50–500", "500–5,000", "5,000+"];

export const REVENUE_RANGES = [
  "Under $10M",
  "$10M–$50M",
  "$50M–$200M",
  "$200M–$1B",
  "Over $1B",
  "Prefer not to say",
];

export const REGULATORY = ["US", "EU", "China", "Other"];

export const ACTIVE_CONCERNS = [
  "US-China trade tensions",
  "Shipping route disruption",
  "Energy supply security & price volatility",
  "Supply chain disruption",
  "Critical minerals & rare earth access",
  "Export controls & chips access",
  "Data localisation & digital regulation",
  "Currency & capital flow risk",
  "Political instability in operating markets",
  "Sanctions exposure",
  "Forced labour and supply chain due diligence compliance",
  "Technology transfer and IP risk",
  "Other",
];

export const PLANNING_HORIZONS = ["12 months", "1–3 years", "3–5 years", "5+ years", "N/A"];

export const STATUSES = ["All", "Pending", "Email Captured", "In Review", "Assessment Ready"];

// Admin workflow statuses — manually managed by Aurora reviewers.
// Distinct from the technical `status` field (which tracks generation).
export const ADMIN_STATUSES = ["New", "In Review", "Report Sent", "Archived"];
export const ADMIN_STATUS_COLORS = {
  New: "#A88059",
  "In Review": "#D49A36",
  "Report Sent": "#2E7D32",
  Archived: "#6B5E4A",
};

export const tierColor = (tier) => {
  const t = (tier || "").toLowerCase();
  if (t.includes("low")) return "#2E7D32";
  if (t.includes("moderate")) return "#D49A36";
  if (t.includes("elevated")) return "#D84315";
  if (t.includes("critical")) return "#B71C1C";
  return "#A88059";
};

export const scoreTier = (score) => {
  if (score <= 3) return "Low";
  if (score <= 6) return "Moderate";
  if (score <= 8) return "Elevated";
  return "Critical";
};
